import React, { useState, useEffect } from 'react'
import { Box, Grid, Card, Flex, Group, ThemeIcon, Text, Button, NumberFormatter, Center, Loader, ScrollArea, SimpleGrid, Switch, Badge, Modal, Menu, ActionIcon } from '@mantine/core'
import { IconPackage, IconWallet, IconDotsVertical, IconPencil, IconTrash } from '@tabler/icons-react'
import classes from '../../../../assets/module-css/AdminLayout.module.css'
import { useSelector, useDispatch } from 'react-redux'
import { updateOrder, deleteAdditionalLogistic } from '../../../../services/orders'
import { useParams } from 'react-router-dom'
import { getOrderDetail } from '../../../../store/orderDetail'
import { notificationSuccess, notificationError, loadingNotification, completedLoadingNotification } from '../../../ui/Notifications'
import { calculation } from '../../../../services/calculation'
import { shipmentMethod, additionalCharge } from '../../../../helper/master-unit'
import { modalDeleteDataAdditionalLogistic } from '../../../ui/Prompt/modalDeleteDataAdditionalLogistic'
import FormAdjustShipmentMethod from './Form/FormAdjustShipmentMethod'
import FormAdjustAdditionalLogistic from './Form/FormAdjustAdditionalLogistic'

const OrderLogisticCharges = () => {
  const { isLoadingOrder, summary, general, logistic } = useSelector(state => state.order_detail)
  const dispatch = useDispatch()
  const params = useParams()
  const orderId = params.order_id
  const [usedCalculation, setUsedCalculation] = useState('')
  const [totalShipmentMethod, setTotalShipmentMethod] = useState(0)
  const [totalAdditionalLogistic, setTotalAdditionalLogistic] = useState(0)
  const [loadingForm, setLoadingForm] = useState(false)
  const [showCharge, setShowCharge] = useState(false)
  const [openModalShipmentMethod, setOpenModalShipmentMethod] = useState(false)
  const [openModalAdditionalLogistic, setOpenModalAdditionalLogistic] = useState(false)
  const [detailData, setDetailData] = useState(null)
  const [additionalChargeId, setAdditionalChargeId] = useState(null)


  const handleCalculation = async () => {
  const loadingCalculation = loadingNotification('Waiting Calculation Order', 'Please Wait. . .')
    const responseCalculation = await calculation(orderId)
    if (responseCalculation.success) {
      dispatch(getOrderDetail(orderId))
      completedLoadingNotification(loadingCalculation, 'Calculation Order Successfully', 'This order has been completed in calculation')
    }
  }

  const handleChangeShowCharge = async (status) => {
    setLoadingForm(true)
    const payload = {
      show_volume_weight_charge: status
    }
    try {
      const response = await updateOrder(orderId, payload)
      if (response.success) {
        setShowCharge(status)
        notificationSuccess('Update Order Successfully', 'This data has been updated')
        handleCalculation()
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      notificationError('Update Order Error', `${errorMessage ? errorMessage : 'Please recheck your form'}`)
    } finally {
      setLoadingForm(false)
    }
  }

  const handleDeleteAdditionalLogistic = (data) => {
    modalDeleteDataAdditionalLogistic('Additional Logistic', orderId, data.additionalChargeId, data.id, data.name, deleteAdditionalLogistic, handleCalculation)
  }

  const calculateData = (array, property) => {
    return array.reduce((sum, obj) => sum + (obj[property] || 0), 0)
  }

  const checkShipmentMethod = (shipmentMethod) => {
    let data = ''
    if (shipmentMethod === 'ocean' || shipmentMethod === 'ocean_dtd') {
      data = 'Cbm'
    } else {
      data = 'Weight'
    }
    setUsedCalculation(data)
    calculateTotalShipmentMethod(data)
  }

  const sumAdditionalLogistic = (dataAdditionalLogistic) => {
    const total = calculateData(dataAdditionalLogistic, 'grandTotal')
    setTotalAdditionalLogistic(total)
  }

  const calculateTotalShipmentMethod = (shipmentMethod) => {
    let totalShipment = 0
    if (shipmentMethod === 'Cbm') {
      totalShipment = logistic.revisedTotalCbm
        ? logistic.logisticPerUnit * logistic.revisedTotalCbm
        : logistic.logisticPerUnit * logistic.totalCbm
    } else {
      totalShipment = logistic.revisedTotalWeight
        ? logistic.logisticPerUnit * logistic.revisedTotalWeight
        : logistic.logisticPerUnit * logistic.totalWeight
    }
    setTotalShipmentMethod(totalShipment)
  }

  useEffect(() => {
    if (!isLoadingOrder) {
      checkShipmentMethod(logistic.shipmentMethod)
      sumAdditionalLogistic(logistic.additionalLogistic)
    }
    // eslint-disable-next-line
  }, [logistic, isLoadingOrder])

  useEffect(() => {
    if (!isLoadingOrder) {
      handleSetShowCharge(general.showVolumeWeightCharge)
    }
    // eslint-disable-next-line
  }, [general, isLoadingOrder])

  const handleEditShipmentMethod = (data) => {
    setDetailData(data)
    setOpenModalShipmentMethod(true)
  }

  const onCloseModalShipmentMethod = () => {
    setDetailData(null)
    setOpenModalShipmentMethod(false)
  }

  const handleEditAdditionalLogistic = (data) => {
    setDetailData(data)
    setAdditionalChargeId(data.additionalChargeId)
    setOpenModalAdditionalLogistic(true)
  }

  const onCloseModalAdditionalLogistic = () => {
    setDetailData(null)
    setAdditionalChargeId(null)
    setOpenModalAdditionalLogistic(false)
  }

  const handleSetShowCharge = (value) => {
    setShowCharge(value === 1 ? true : false)
  }

  const loadingDataLogistic = () => {
    return (
      <Center h={200}>
        <Loader size='md' type='dots' />
      </Center>
    )
  }

  const mappingDataLogistic = (calculation) => {
    if (calculation === 'Cbm') {
      return (
        <Group gap={!isLoadingOrder ? logistic.revisedTotalCbm ? 4 : 2 : 0} align='center'>
          {!isLoadingOrder ? <Box className={logistic.revisedTotalCbm ? classes.PulseAnimation : ''}><Text fz={14} td={logistic.revisedTotalCbm ? 'line-through' : ''} c={logistic.revisedTotalCbm ? 'red' : 'black'}>{logistic.totalCbm}</Text></Box> : ''}
          {!isLoadingOrder ? <Text fz={14} c='black'>{logistic.revisedTotalCbm} {` Cbm`}</Text> : ''}
        </Group>
      )
    } else {
      return (
        <Group gap={!isLoadingOrder ? logistic.revisedTotalWeight ? 4 : 2 : 0} align='center'>
          {!isLoadingOrder ? <Box className={logistic.revisedTotalWeight ? classes.PulseAnimation : ''}><Text fz={14} td={logistic.revisedTotalWeight ? 'line-through' : ''} c={logistic.revisedTotalWeight ? 'red' : 'black'}>{logistic.totalWeight}</Text></Box> : ''}
          {!isLoadingOrder ? <Text fz={14} c='black'>{logistic.revisedTotalWeight}{` Kg`}</Text> : ''}
        </Group>
      )
    }
  }

  const mappingDataAdditionalLogistic = (dataLogistic) => {
    if (dataLogistic.length > 0) {
      const remapDataLogistic = (data) => data.map((val, index) => {
        return (
          <Card.Section withBorder px="md" py={13} key={index}>
            <SimpleGrid cols={3} spacing="xs" verticalSpacing="xs">
              <Flex align='center' gap='xs'>
                <ThemeIcon variant="light" color="blue" radius='xl'>
                  <IconWallet style={{ width: '70%', height: '70%' }} />
                </ThemeIcon>
                <Text fz={14} fw={500} c='gray.8' tt='capitalize' lineClamp={2}>{val.name}</Text>
              </Flex>
              <Flex justify='center' align='center'>
                <Text fz={14} fw={500} c='gray.8'>{additionalCharge[val.chargeLabel.toUpperCase()]}</Text>
              </Flex>
              <Flex justify='space-between' align='center'>
                <Text fz={14} fw={600}> <NumberFormatter prefix={`${!isLoadingOrder ? summary.orderCurrency : ''} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={!isLoadingOrder ? val.grandTotal : 0} /></Text>
                <Menu width={120} position="bottom-end" withArrow arrowPosition="center">
                  <Menu.Target>
                    <ActionIcon ml={8} variant='transparent' size='xs'>
                      <IconDotsVertical stroke={1.5} />
                    </ActionIcon>
                  </Menu.Target>
                  <Menu.Dropdown>
                    <Menu.Item
                      leftSection={<IconPencil stroke={1.5} size={14} />}
                      onClick={() => handleEditAdditionalLogistic(val)}
                      fw='600'
                      fz={11}
                    >
                      Edit
                    </Menu.Item>
                    <Menu.Item
                      color='red'
                      leftSection={<IconTrash stroke={1.5} size={14} />}
                      onClick={() => handleDeleteAdditionalLogistic(val)}
                      fw='600'
                      fz={11}
                    >
                      Delete
                    </Menu.Item>
                  </Menu.Dropdown>
                </Menu>
              </Flex>
            </SimpleGrid>
          </Card.Section>
        )
      })
      return (
        <ScrollArea w='auto' h={300} overscrollBehavior="contain" offsetScrollbars scrollbarSize={6} scrollbars="y" mt={16}>
          {remapDataLogistic(dataLogistic)}
        </ScrollArea>
      )
    } else {
      return (
        <Card.Section withBorder inheritPadding h={200}>
          <Center h={200}>
            <Text fz={14} fw={500} c='gray.6'>No Data Additional Logistic Found</Text>
          </Center>
        </Card.Section>
      )
    }
  }

  const mappingFormCharge = () => {
    return (
      <Group align='center' gap='xs'>
        <Switch
          checked={showCharge}
          onChange={(event) => handleChangeShowCharge(event.currentTarget.checked)}
          size='xs'
        />
        <Badge variant="light" color={showCharge ? 'teal' : 'red'} tt='capitalize' fw='500'>{showCharge ? 'Enabled' : 'Disabled'}</Badge>
      </Group>
    )
  }


  return (
    <Box>
      <Box my={20}>
        <Grid align='start' overflow='hidden'>
          <Grid.Col span={6}>
            <Card withBorder shadow="xs" radius="md" padding='md' h={300}>
              <Card.Section withBorder inheritPadding py="xs">
                <Flex justify='space-between' align='center' py={10}>
                  <Text fz={16} fw={600}>Shipment Method</Text>
                  <Button size='compact-xs' variant="outline" color='black' onClick={() => handleEditShipmentMethod(logistic)}>Edit</Button>
                </Flex>
              </Card.Section>
              <Card.Section withBorder inheritPadding py={13}>
                <Flex justify='space-between' align='center'>
                  <Group align='center' gap='xs'>
                    <ThemeIcon variant="light" color="blue" radius='xl'>
                      <IconPackage style={{ width: '70%', height: '70%' }} />
                    </ThemeIcon>
                    <Text fz={14} fw={500} c='gray.8' tt='capitalize'>{!isLoadingOrder ? shipmentMethod[logistic.shipmentMethod] : ''}</Text>
                  </Group>
                  <Box>
                    <Text fz={14} fw={500}> <NumberFormatter prefix={`${!isLoadingOrder ? summary.orderCurrency : ''} `} suffix={`${usedCalculation === 'Cbm' ? ' / Cbm' : ' / Weight (Kg)'}`} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={!isLoadingOrder ? logistic.logisticPerUnit : 0} /></Text>
                  </Box>
                </Flex>
              </Card.Section>
              <Card.Section withBorder inheritPadding py={13}>
                <Flex justify='space-between' align='center'>
                  <Group align='center' gap='xs'>
                    <ThemeIcon variant="light" color="blue" radius='xl'>
                      <IconPackage style={{ width: '70%', height: '70%' }} />
                    </ThemeIcon>
                    <Text fz={14} fw={500} c='gray.8' tt='capitalize'>{usedCalculation === 'Cbm' ? 'Total CBM' : 'Total Weight'}</Text>
                  </Group>
                  <Box>
                    {mappingDataLogistic(usedCalculation)}
                  </Box>
                </Flex>
              </Card.Section>
              <Box my={8}>
                <Flex Flex justify='space-between' align='flex-start'>
                  <Group align='center' gap='xs'>
                    <Text fz={14} fw={500} c='gray.7'>Total Shipment Charges</Text>
                  </Group>
                  <Box>
                    {!isLoadingOrder ? <Text fz={14} fw={500}> <NumberFormatter prefix={`${summary.orderCurrency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={totalShipmentMethod} /></Text> : ''}
                  </Box>
                </Flex>
              </Box>
            </Card>
          </Grid.Col>
          <Grid.Col span={6}>
            <Card withBorder shadow="xs" radius="md" padding='md' h={300}>
              <Card.Section withBorder inheritPadding py="xs">
                <Flex justify='space-between' align='center' py={10}>
                  <Text fz={16} fw={600}>Additional Logistic</Text>
                  <Button size='compact-xs' variant="outline" color='black' onClick={() => [setOpenModalAdditionalLogistic(true), setAdditionalChargeId(logistic.additionalLogisticId)]}>Add</Button>
                </Flex>
              </Card.Section>
              {!isLoadingOrder ? mappingDataAdditionalLogistic(logistic.additionalLogistic) : loadingDataLogistic()}
              <Card.Section withBorder inheritPadding>
                <Box my={8}>
                  <Flex Flex justify='space-between' align='flex-start'>
                    <Group align='center' gap='xs'>
                      <Text fz={14} fw={500} c='gray.7'>Total Additional Logistic Charges</Text>
                    </Group>
                    <Box>
                      {!isLoadingOrder ? <Text fz={14} fw={500}> <NumberFormatter prefix={`${summary.orderCurrency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={totalAdditionalLogistic} /></Text> : ''}
                    </Box>
                  </Flex>
                </Box>
              </Card.Section>
            </Card>
          </Grid.Col>
          <Grid.Col span={6}>
            <Card withBorder shadow="xs" radius="md" padding='md'>
              <Flex justify='space-between' align='center'>
                <Text fz={12} fw='600'>Show Volume / Weight Charge</Text>
                {!loadingForm ? mappingFormCharge() : <Loader size='xs' />}
              </Flex>
            </Card>
          </Grid.Col>
          <Grid.Col span={6}>
            <Flex justify='space-between' align='start' px={4}>
              <Box>
                <Text fz={14} fw={600}>Total Logistic Charges</Text>
                <Text fz={12} c='gray.6'>(Shipment method + Additional Logistic)</Text>
              </Box>
              {!isLoadingOrder ? <Text fz={14} fw={500}> <NumberFormatter prefix={`${summary.orderCurrency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={!isLoadingOrder ? logistic.totalLogisticCharges : 0} /></Text> : ''}
            </Flex>
          </Grid.Col>
        </Grid>
        <Box mt={24}>
          <Text fz={12} mb={4} c='violet.9'>** Grand total of Shipment Method & Additional Logistic will be "Total Logistic Charge"</Text>
          <Text fz={12} c='violet.9'>** Grand total of "Total Logistic Charge" and "Total custom charges" will be "Total Logistic All In"</Text>
        </Box>
      </Box>
      <Modal opened={openModalShipmentMethod} onClose={onCloseModalShipmentMethod} centered closeOnClickOutside={false} size='lg' title={<Text fw='Bold'>Edit Shipment Method</Text>} withCloseButton={false}>
        <FormAdjustShipmentMethod dataShipment={detailData} onCloseForm={onCloseModalShipmentMethod} />
      </Modal>
      <Modal opened={openModalAdditionalLogistic} onClose={onCloseModalAdditionalLogistic} centered closeOnClickOutside={false} size='lg' title={<Text fw='Bold'>{detailData !== null ? 'Update' : 'Add'} Additional Logistic</Text>} withCloseButton={false}>
        <FormAdjustAdditionalLogistic dataLogistic={detailData} additionalChargeId={additionalChargeId} onCloseForm={onCloseModalAdditionalLogistic} />
      </Modal>
    </Box>
  )
} 

export default OrderLogisticCharges